// extracted by mini-css-extract-plugin
export default {"btn":"SmartSelect_complete_btn__Mbgnk","btn-success":"SmartSelect_complete_btn-success__0rE+H","label":"SmartSelect_complete_label__tPuZG","logo":"SmartSelect_complete_logo__tOyA6"};